export function eventListing() {    
    $('.open-filter-box-button').click(function () {
        $('.filter-box').addClass('active');
    });

    $('.close-filterbox').click(function () {
        $('.filter-box').removeClass('active');
    });

    $('.reset-filterbox').click(function () {        
        window.location.replace(window.home + '/events');
    });

    $('input[type=checkbox]').click(function(){
        $(this).closest('form').submit();
    });

    $('input[type=radio]').click(function(){
        $(this).closest('form').submit();
    });

    $('input[data-tag=daterange]').change(function(){
        $(this).closest('form').submit();
    });
};


// WEBPACK FOOTER //
// ./c:/Projects/UB/unlimitedbiking.com/wp-content/themes/unlimitedbiking/slice/assets/js/modules/eventListing.js